<div class="cnt-page-internal">
    <div class="row-title">
        <teiasoft-title [title]="'enquiryBook.title' | translate"></teiasoft-title>
    </div>
    <!-- TOOLBAR -->
    <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)"
        style="width: 100%;"></teiasoft-toolbar>
    <!-- GRID [columns]="columns"  -->
    <!--     <div class="eb-cnt-odata"> -->
    <teiasoft-grid-odata [columnsToHideGOD]="columnsToHide" [columnsToShowRow]="columnsToShowRowExpand"
        [customIcoCols]="customIcoCols" [cellSpecialStyles]="cellSpecialStyles" [calculatedCols]="calculatedCols"
        [oDataUrl]="oDataUrl" [odataEntity]="'VEnquiry'" [sortable]="true" [theme]="globals.theme!" style="width:100%"
        [selectable]="false" [enableDoubleClick]="true" [disableAllSelection]="false" [filterable]="gridFilterable"
        [clearFilters]="clearFilters" [dateFormat]="globals.dateFormat!" [dateTimeFormat]="globals.dateTimeFormat!"
        [autoWidth]="true" [showSettingsDialog]="showSettingsDialog"
        (onCloseDialogSettings)="showSettingsDialog = false" [gridConfiguration]="gridConfiguration"
        [refreshGridKey]="refreshGridKey" [columnsWidth]="columnsWidth" (customIconClick)="customIconClick($event)"
        (onUpdateConfiguration)="onUpdateConfiguration($event)" (onGetOdataEntity)="onGetOdataEntity($event)"
        [dataSetRow]="dataSetItems" [columnsToHideRow]="columnsToHideItems" (onCellClick)="onCellClick($event)"
        (customIconContextMenuClick)="onExpandedGridContextMenuClick($event)"
        [exportToExcel]="exportToExcel" (onActiveFiltersUpdate)="onActiveFiltersUpdate($event)"
        [expandedEnquiryNo]="expandedEnquiryNo!" [paginable]="true" [rowsPerPage]="100"
        [expandedGridVirtualScroll]="true"
        [roundDigits]="roundDigitsForGrid" [roundDigitsItems]="roundDigitsForItemEditGrid"
        [headerParametersValues]="headerParametersValues" [enableStickyColumnsAtStart]="true" [origin]="'enquiry-book'"
        [filtersToHide]="filtersToHide" [filterScope]="enquiryBookFilterScope" [customRenderers]="customRenderers"
        [customHeaderRenderers]="customHeaderRenderers"
        [expandedGridDescriptionExtraTemplate]="expandedItemsGridTotalsTemplate"
        [expandedGridDescriptionExtraContext]="{
            hasTotals: hasExpandedEnquiryTotals(),
            totalPrice: expandedEnquiryTotalPriceFormatted,
            totalMargin: expandedEnquiryTotalMarginFormatted,
            marginClass: expandedEnquiryTotalMarginClass
        }"
        [initialFilters]="enquiryInitialFilters" [showFiltersOnLoad]="showFiltersOnLoad">
    </teiasoft-grid-odata>
    <!--     </div> -->

</div>

<!-- DIALOG -->
<!-- [itemParameterValues]="itemParameterValues" -->
<teiasoft-dialog *ngIf="showAddDialog" [theme]="globals.theme!" [isMobile]="false" [dialogTitle]="dialogTitle"
    [dialogIcon]="dialogIcon" [dialogButtons]="dialogButtons" [dialogForm]="enquiryForm" [display]="'row'"
    [elementPerRow]="elementPerRow" (onButtonClick)="onDialogButtonClick($event)"
    (onFormButtonClick)="onFormButtonClick($event)" (onFormSelectChanged)="onFormSelectChanged($event)"
    (onFormSelectListChanged)="onFormSelectListChanged($event)"
    (onFormAutocompleteChanged)="onFormAutocompleteChanged($event)"
    (onFormAutocompleteChangedRows)="onFormAutocompleteChangedRows($event)"
    (onFormAutocompletLinkClicked)="onFormAutocompletLinkClicked($event)"
    (onFormAutocompleteInputChange)="onFormAutocompleteInputChange($event)"
    (onFormAutocompleteRemoveElement)="onFormAutocompleteRemoveElement($event)"
    [roundDigitsForEnquiryForm]="roundDigitsForEnquiryForm"></teiasoft-dialog>

<!-- CONFIRM  MODAL -->
<teiasoft-modal (onConfirmClick)="onConfirmModal($event)" [theme]="globals.theme!"
    [isMobile]="!globals.isDesktop!"></teiasoft-modal>

<!-- MODAL SELECT CUSTOMER -->
<!-- <app-modal-select-customer *ngIf="showSelectCustomer" (onCloseModal)="showSelectCustomer = false" [modalTitle]="'enquiryBook.selectCustomer' | translate"
(onConfirmModal)="onConfirmModalCustomer($event)" [modalTitle]="'toolbar.selectCustomer' | translate" [dataSet]="dataSetCustomers" 
    [columns]="columnsCustomers" [columnsToHide]="columnsToHideCustomer"></app-modal-select-customer> -->

<!-- MODAL CREATE/EDIT DUMMY -->
<app-create-edit-dummy *ngIf="showCreateEditDummy" (onCloseModal)="showCreateEditDummy = false"
    [countries]="headerParametersValues.countries!" [isCreate]="isCreateDummy"
    (onSavaData)="onCreateEditDummyCustomer($event)" [dummyCustomer]="dummyCustomer!"></app-create-edit-dummy>

<!-- MODAL SELECT NPS -->
<app-modal-select-nps *ngIf="showSelectNps" (onCloseModalNps)="onCloseModalNps($event)" [dataSet]="dataSetNps"
    [modalTitle]="'enquiryBook.selectNps' | translate" [columns]="columnsNps" [columnsToHide]="columnsToHideNps"
    (onConfirmModalNps)="onConfirmModalNps($event)" [selectedRow]="selectedNpsRow"
    [columnsToFilter]="columnsToFilterNps"></app-modal-select-nps>

<!-- MODAL EDIT ENQUIRY -->
<app-edit-enquiry *ngIf="showEditEnquiry" [isMobile]="false" [theme]="globals.theme!" [enquiryForm]="enquiryForm"
    [enquiryToEdit]="enquiryToEdit" (returnEnquiryBookClick)="onReturnToEnquiryBook($event)"
    (reloadEnquiry)="reloadEnquiry($event)" [itemToDelete]="itemToDelete"
    (dialogButtonClick)="dialogButtonClick($event)" [roundDigitsForEnquiryEditGrid]="roundDigitsForEnquiryEditGrid"
    [roundDigitsForItemEditGrid]="roundDigitsForItemEditGrid" [roundDigitsForItemForm]="roundDigitsForItemForm"
    [roundDigitsForEditInPlace]="roundDigitsForEditInPlace" [roundDigitsForEnquiryForm]="roundDigitsForEnquiryForm"
    [showAIDialog]="showUploadFromAI" (searchSimilarEnquiriesClick)="onSearchForSimilarEnquiries($event)"
    (onOpenITDCR)="onOpenItdcrClick($event)" [openEditPricesTrigger]="openEditPricesTrigger"></app-edit-enquiry>

<!-- MODAL DUPLICATE ENQUIRY RESULT -->
<app-duplicate-enquiry-result *ngIf="showDuplicateEnquiry" [isMobile]="false" [theme]="globals.theme!"
    [message]="'enquiryBook.enquiryCreatedSuccess' | translate" [enquiryNo]="selectedEnquiryNo"
    (openEnquiryInEdit)="openEnquiryInEdit($event)" (closeDuplicateModal)="showDuplicateEnquiry = false">
</app-duplicate-enquiry-result>

<!-- MODAL CLOSE ENQUIRY -->
<app-close-enquiry *ngIf="showCloseEnquiry" [isMobile]="false" [theme]="globals.theme!" [enquiryNo]="selectedEnquiryNo"
    (closeEnquiry)="closeEnquiry($event)" (closeCloseEnquiryModal)="showCloseEnquiry = false"
    [enquiryStatus]="selectedEnquiryStatus" [columnsToShowItem]="closeEnquiryColumnsToShowRow" [calculatedCols]="calculatedCols"
    [customRenderers]="customRenderers" [customHeaderRenderers]="customHeaderRenderers">
</app-close-enquiry>

<!-- MODAL ATTACHMENTS -->
<app-modal-attach *ngIf="showAttachments" [itemAttachments]="itemAttachments" [enquiryAttachments]="enquiryAttachments"
    (closeAttachments)="onCloseAttachments($event)">
</app-modal-attach>

<!-- MODAL CHANGE STATUS -->
<app-change-status *ngIf="showChangeStatus" [enquiryNo]="changeStatusEnquiryNo"
    (closeChageStatusModal)="showChangeStatus = false" [enquiryOfferStatus]="enquiryOfferStatus" [mstOfferStatus]="headerParametersValues.mstOfferStatus!"
    [value]="enquiryMsOfferStatus" (closeAndReload)="closeAndReload($event)"></app-change-status>

<!-- MODAL DOCUMENT TEMPLATE -->
<app-document-template-options *ngIf="showDocumentTemplateOptions" (onSelectUpload)="handleUploadQuotation($event)"
    (onSelectGenerate)="handleOpenQuotationTool()" (onCancel)="showDocumentTemplateOptions = false">
</app-document-template-options>
<app-document-template *ngIf="showDocumentTemplate" [theme]="globals.theme!" [enquiryNo]="showDocumentTemplateEnquiryNo"
    [enquiryStatus]="showDocumentTemplateEnquiryStatus"
    (closeModal)="onCloseQuotationModal($event)"></app-document-template>

<!-- MODAL EXTRA COSTS -->
<app-modal-extra-costs *ngIf="showExtraCosts" [readOnly]="true" (onCancel)="showExtraCosts = false"
    [enquiryNo]="expandedEnquiryNo!" [enquiryHeader]="expandedEnquiryHeader!" [item]="selectedExtraCostItem!">
</app-modal-extra-costs>
<!-- MODAL DELIVERY DATES -->
<app-modal-item-delivery-dates *ngIf="showItemDeliveryDates" (onCancel)="showItemDeliveryDates = false"
    [enquiryNo]="expandedEnquiryNo!" [item]="selectedDeliveryDatesItem!">
</app-modal-item-delivery-dates>

<!-- MODAL SIMILIAR ENQUIRIES -->
<app-modal-similar-enquiries *ngIf="showSimilarEnquiriesModal" [projectName]="pendingEnquiry?.projectName!"
    [enquiryNo]="similarEnquiriesEnquiryNo" (onSkip)="onSkipCheckSimilarEnquiries()" (onCancel)="onAbortCreation()"
    (onClose)="onAbortCreation()"></app-modal-similar-enquiries>

<!-- MODAL IDTCR -->
<app-modal-itdcr *ngIf="showOpenIDTCR" [enquiryNo]="openIDTCR_EnquiryNo!" [itemNo]="openIDTCR_ItemNo!"
    (onCancel)="showOpenIDTCR = false" (onClose)="onCompleteItdcr($event)" [columnsToShowItem]="columnsToShowRow"
    [calculatedCols]="calculatedCols" [customRenderers]="customRenderers"
    [customHeaderRenderers]="customHeaderRenderers"
    [sourceEvent]="openIDTCR_Source"></app-modal-itdcr>
<app-modal-view-itdcr *ngIf="showItdcrViewerModal" [itdcrNo]="itdcrViewerNo" [showHistory]="itdcrViewerShowHistory"
    (onClose)="onCloseItdcrViewer()"></app-modal-view-itdcr>

<!-- MODAL SPECIAL REQUIREMENTS -->
<app-modal-special-requirements *ngIf="showSpecialRequirements" (onClose)="showSpecialRequirements = false"
    (onSave)="onSaveSpecialeRequirements($event)"
    [readOnly]="specialRequirementsReadOnly"
    [initialCustomerSpecialRequirements]="this.customerSpecialRequirements"></app-modal-special-requirements>

<app-modal-revision *ngIf="showReopenModal" (onClose)="showReopenModal = false"
    (onSave)="onSaveRevision($event)" [enquiryNo]="selectedEnquiryNo"></app-modal-revision>

<app-modal-price-margin-changes *ngIf="showPriceMarginChangesModal" [isMobile]="false" [theme]="globals.theme!"
    [enquiryNo]="priceMarginChangesEnquiryNo" [masterItems]="priceMarginChangesMasterItems"
    [allowReverse]="priceMarginChangesAllowReverse" (onGoToOverview)="onPriceMarginChangesGoToOverview()"
    (onGoToEditPrices)="onPriceMarginChangesGoToEditPrices()"
    (onReverse)="onPriceMarginChangesReverse()" [customHeaderRenderers]="customHeaderRenderers"></app-modal-price-margin-changes>

<!-- custom grid cells -->
<ng-template #viewCostHeader let-column="column">
    <span>{{getCostColumnHeaderLabel(column)}}</span>
</ng-template>

<ng-template #viewCost let-row let-column="column" let-uomColumn="uomColumn">
    <div class="extra-cost-row">
        <span style="margin-right: 0.2vw;">{{row[column] && row[column].toFixed(2)}}</span>
    </div>
</ng-template>
<ng-template #viewExtraCosts let-row>
    <div class="extra-cost-row">
        <span style="margin-right: 0.2vw;">{{row.extraCosts!! && row.extraCosts.toFixed(2)}}</span>
        <div *ngIf="row.extraCosts" class="extra-cost-ico-cell"><i (click)="onItemExtraCostsClick(row)"
                class="extra-cost-icon fal fa-magnifying-glass"></i></div>
    </div>
</ng-template>
<ng-template #viewDeliveryDates let-row>
    <div class="extra-cost-row">
        <span style="margin-right: 0.1vw;">{{getItemRowMinDeliveryDate(row)}}</span>
        <span style="margin-right: 0.2vw;" *ngIf="getItemRowDeliveryDatesCollection(row).length > 1">*</span>
        <div *ngIf="getItemRowDeliveryDatesCollection(row).length > 1" class="extra-cost-ico-cell"><i
                (click)="onItemDeliveryDatesClick(row)" class="extra-cost-icon fal fa-magnifying-glass"></i></div>
    </div>
</ng-template>
<ng-template #expandedItemsGridTotalsTemplate let-hasTotals="hasTotals" let-totalPrice="totalPrice"
    let-totalMargin="totalMargin" let-marginClass="marginClass">
    <div *ngIf="hasTotals" class="total-margin">
        <div class="total-row">
            <span>{{'enquiryBook.overallPrice' | translate}} :</span>
            <span>{{totalPrice}}</span>
        </div>
        <div class="total-row">
            <span [ngClass]="marginClass">{{'enquiryBook.overallMargin' | translate}} :</span>
            <span [ngClass]="marginClass">{{totalMargin}}</span>
        </div>
    </div>
</ng-template>
